import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var e = {
  namespace: void 0,
  performanceLogger: function performanceLogger() {},
  eventHandlerInterceptor: void 0,
  styleApplyer: function styleApplyer(e, r, o) {
    e.style[r] = o;
  }
},
    r = function r(_r) {
  return _objectSpread(_objectSpread({}, e), _r);
};

export { r as applyDefaultProjectionOptions };